import { Box, BoxProps, Flex, Text } from "@chakra-ui/react";
import { ReactNode, SVGProps } from "react";
import { MessageArrow } from "../arrow-message";
import { Message } from "components/atendimentos-components/whatsapp-attendances/components/whats-app-chat/hooks/use-whats-app-session-controls/types";

export const MessageContainer = ({
  children,
  isMyMessage,
  containerProps,
  messageArrowProps,
  message,
}: {
  children: ReactNode;
  isMyMessage: boolean;
  containerProps?: BoxProps;
  messageArrowProps?: SVGProps<SVGSVGElement>;
  message?: Message;
}) => {
  const { timestamp, type } = message || {};
  return (
    <Flex
      w="100%"
      justifyContent={isMyMessage ? "flex-end" : "flex-start"}
      p="2px 8px"
    >
      <Box
        maxW="300px"
        w={type === "chat" ? "auto" : "60%"}
        bg={isMyMessage ? "#d9fdd3" : "#ffffff"}
        borderRadius={isMyMessage ? "6px 0px 6px 6px" : "0px 6px 6px 6px"}
        p={
          type === "chat"
            ? "6px 55px 6px 9px"
            : type === "image"
            ? "3px 4px 5px 3px"
            : type === "audio" || type === "ptt"
            ? "6px 7px 10px 9px"
            : "3px 4px 12px 3px"
        }
        textAlign="start"
        pos="relative"
        {...containerProps}
      >
        <Box
          transform={
            isMyMessage ? "translate(100%,0) rotate(270deg)" : "translate(0%,0)"
          }
          top="0"
          right={isMyMessage ? "0" : "100%"}
          w="12px"
          h="12px"
          pos="absolute"
          color={isMyMessage ? "#d9fdd3" : "#ffffff"}
        >
          <MessageArrow {...messageArrowProps} />
        </Box>
        {children}
        {timestamp && (
          <Text
            pos="absolute"
            bg={isMyMessage ? "#d9fdd3" : "#ffffff"}
            bottom="5px"
            right="4px"
            borderRadius="10px 0 0 0"
            pr="12px"
            pl="8px"
            pt="2px"
            // transform="translateY(100%)"
            fontSize="10px"
            color="gray.500"
            whiteSpace="nowrap"
          >
            {`${formatTimestamp(Number(timestamp))}`}
          </Text>
        )}
      </Box>
    </Flex>
  );
};

export function formatTimestamp(timestamp: number) {
  const date = new Date(timestamp * 1000);
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}
